import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

import { DateAdapter } from '@angular/material/core';
import {
  NavigationHeaderComponent,
  headerItem,
} from '@standard-angular-utilities/shared-components';
import { UserService } from 'src/app/Services/user-service';
import timelogRouteConfig from './Routes';
import { SharedFunctionsService } from 'src/app/Services/sharedFunctions.service';
@Component({
  selector: 'timelog-base-root',
  templateUrl: './timelog-base.component.html',
  styleUrl: './timelog-base.component.css',
  imports: [RouterModule, RouterOutlet, NavigationHeaderComponent],
})
export class TimelogBaseComponent {
  get currentUser() {
    return this.userService.currentUser;
  }
  constructor(
    public userService: UserService,
    private sharedFunctionsService: SharedFunctionsService
  ) {
    if (!this.currentUser) {
      this.userService.userStatusChanged$.subscribe((result) => {
        if (result) {
          this.addRoutes();
        }
      });
    } else {
      this.addRoutes();
    }
  }

  addRoutes() {
    if (!this.currentUser) {
      return;
    }

    this.userService.setRouteConfig(timelogRouteConfig);
  }
}
